import { useEffect } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/site/PageShell";
import { WhatsAppLink } from "@/components/site/WhatsAppLink";
import { useMarketingConfig } from "@/components/site/MarketingConfigProvider";

// Página de conversión para Google Ads: no se indexa ni se comparte, solo
// sirve como destino del redirect tras un envío exitoso de LeadForm y como
// URL de conversión a registrar en la acción de Google Ads correspondiente.
export const Route = createFileRoute("/cotizar/gracias")({
  head: () => ({
    meta: [
      { title: "Solicitud recibida | Improve Yourself" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CotizarGracias,
});

function CotizarGracias() {
  const { googleAdsConversionId, googleAdsConversionLabel } = useMarketingConfig();

  useEffect(() => {
    const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    if (
      typeof gtag === "function" &&
      !isLocal &&
      googleAdsConversionId &&
      googleAdsConversionLabel
    ) {
      gtag("event", "conversion", {
        send_to: `${googleAdsConversionId}/${googleAdsConversionLabel}`,
      });
    }
  }, [googleAdsConversionId, googleAdsConversionLabel]);

  return (
    <PageShell>
      <PageHero
        eyebrow="· Gracias"
        h1="¡Recibimos tu solicitud!"
        intro="Ya está en manos de nuestro equipo comercial. Te contactamos en menos de 24 horas hábiles para afinar el brief."
      />

      <section className="pb-24">
        <div className="mx-auto max-w-2xl px-5 md:px-8">
          <div className="rounded-2xl border border-border bg-surface p-6 text-secondary/80">
            <p className="font-display text-lg font-bold text-secondary">¿Qué pasa después?</p>
            <ol className="mt-3 list-decimal space-y-2 pl-5">
              <li>Te contactamos para aclarar dudas del brief.</li>
              <li>Te enviamos propuesta y presupuesto detallado en menos de 72 horas.</li>
              <li>Coordinamos fecha, zona y detalles de ejecución.</li>
            </ol>
          </div>

          <div className="mt-8 flex flex-col items-center gap-4 text-center">
            <WhatsAppLink className="btn-cta rounded-lg px-6 py-3 text-base font-semibold">
              Escribir por WhatsApp ahora
            </WhatsAppLink>
            <Link to="/" className="text-sm font-semibold text-primary hover:underline">
              Volver al inicio
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
